// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import {
  spacing,
  fontSize,
  mediaMax,
  mediaMin,
  borderRadius,
} from 'presentations/views/styles';
import { black, gray04 } from 'presentations/views/styles/color';

interface Props {
  holidays: any;
  holidayMasters: any;
}
export default function Component({ holidays, holidayMasters }: Props) {
  const t = translateInComponent(translations);
  return (
    <Container>
      {Object.entries(holidays).map(([holiday, name]) => {
        const day = t('holidayDate', {
          date: new Date(holiday),
        });
        const description = holidayMasters[String(name)];
        return (
          <HolidayList key={day}>
            <TitleContainer>
              <Title>
                <span id={String(name)}>{day}</span> {String(name)}
              </Title>
            </TitleContainer>
            {description && <Description>{description}</Description>}
          </HolidayList>
        );
      })}
    </Container>
  );
}
const Container = styled.dl`
  border: 1px solid ${gray04};
  border-radius: ${borderRadius()};
`;
const HolidayList = styled.div`
  font-size: ${fontSize(14)};
  :not(:first-of-type) {
    border-top: 1px solid ${gray04};
  }
  ${mediaMin.tablet} {
    font-size: ${fontSize(16)};
  }
`;

const Title = styled.h2`
  padding: ${spacing(16)};
  color: ${black};
`;

const TitleContainer = styled.dt`
  position: relative;
  font-weight: bold;
  ${mediaMax.tablet} {
    display: flex;
    align-items: center;
  }
`;

const Description = styled.dd`
  border-top: 1px solid ${gray04};
  padding: ${spacing(12)} ${spacing(16)} ${spacing(12)};
`;
